import React, { useEffect, useState } from "react";
import ClubsHeader from "../../components/clubs/ClubsHeader";
import { useParams, useSearchParams } from "react-router-dom";
import { UserSliceType } from "../../lib/redux/slices/userSlice";
import { useSelector } from "react-redux";
import {
  useGetAllPlayersQuery,
  useGetAllMembershipsQuery,
  useGetAllWalletQuery,
  useGetAllWalletUsersQuery,
} from "../../lib/redux/services/sections/Customers";
import useCalender from "../../hooks/useCalender";
import CustomersHeader from "../../components/customers/CustomersHeader";
import SkeletonTable from "../../components/skeletons/SkeletonTable";
import ClubsTableSection from "../../components/clubs/ClubsTableSection";
import { coulmnsType } from "../../types";
import { useDebounce } from "../../hooks/useDebounce";
import Pagination from "../../components/global/Pagination";
import RowsPerPageSelect from "../../components/global/RowsPerPageSelect";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import ErrorSection from "../../components/global/ErrorSection";
import WalletTableSection from "../../components/clubs/WalletTable";
import WalletUsersTable from "./WalletUsersTable";
type props ={
   page:"roles" | "users" | "players" | "memberships"|'packages'|'wallet',
   filter:any;
   search:string
   setVoucherType?:any
}
function WalletUsersContent({page,filter,search,setVoucherType}:props) {
  const { customers, inputs, pricing }: DictionaryType = useGetDictionary();
  const playersColumns: coulmnsType = [
    {
      title: inputs.name,
      tag: "player.name",
    },
    {
      title: 'Balance',
      tag: "balance",
    },
    {
      title: 'Expiry',
      tag: "expiry",
    },
    {
      title:'status',
      tag:'status'
    },
    {
      title: "",
      tag: "controll",
    },
  ];

  const [searchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const {id} =useParams()
  const handleRowsChange = (value: number) => {
    setLimit(value);
  };

  const clubId = useSelector((state: UserSliceType) => state.user.selectedClub);
  const sortBy = useSelector((state: any) => state.control.sortingBy);


  const {
    data,
    isLoading,
    isError,
    error,
    refetch,
    isSuccess,
    isFetching,
  } = useGetAllWalletUsersQuery(
    {
      club_id: clubId,
      wallet_id:id,
      name: useDebounce(search),
      limit,
      currentPage,
      ...useDebounce(filter),
      ...sortBy,
    },
    {
      skip: page !== "wallet",
    }
  );

  const { currentDay, currentMonth, currentYear, getMonthName } = useCalender();

  const [date, setDate] = useState({
    day: currentDay.index,
    month: currentMonth.index,
    year: currentYear,
  });
  const renderTable = () => {
    if (
      isLoading ||
      isFetching 
      
    ) {
      return <SkeletonTable />;
    }
    if (isError) {
      return <ErrorSection/>;
    }
   
    return (
      <WalletUsersTable
        data={data}
        columns={ playersColumns }
        page={page}
      />
    );
  };
 useEffect(()=>{
   if(data){
     setVoucherType?.(data?.voucher_type)
   }
 },[data,isSuccess])
  return (
    <>
         {renderTable()}
      <div className=" flex flex-row justify-between items-center w-full pb-4">
        <RowsPerPageSelect
          options={[10, 25, 50, 100]}
          value={limit}
          onChange={handleRowsChange}
          total={
             data?.total
          }
        />

        <div className="w-full flex justify-end items-end">
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={ data
                ? data?.total
                : []
            }
            pageSize={limit}
            onPageChange={(page: any) => setCurrentPage(page)}
          />
        </div>
      </div>
    </>
    

    
  
  );
}

export default WalletUsersContent;
